import { InlineIcon } from "@iconify/react-with-api";
import React from "react";
import RcPagination from "rc-pagination";

interface PagniationProps {
  total: number;
  currentPage?: number;
  pageSize?: number;
  onChange?: (page: number, pageSize: number) => void;
}

export const Pagniation: React.FC<PagniationProps> = (props) => {
  const { total, currentPage = 1, pageSize = 10, onChange } = props;

  return (
    <RcPagination
      total={total}
      current={currentPage}
      pageSize={pageSize}
      prevIcon={<PrevIcon />}
      nextIcon={<NextIcon />}
      jumpNextIcon={<JumpIcon />}
      jumpPrevIcon={<JumpIcon />}
      onChange={onChange}
    />
  );
};

const PrevIcon = () => (
  <button className="rc-pagination-item-link">
    <InlineIcon icon="ic-round-navigate-before" />
  </button>
);

const NextIcon = () => (
  <button className="rc-pagination-item-link">
    <InlineIcon icon="ic-round-navigate-next" />
  </button>
);

const JumpIcon = () => (
  <button className="rc-pagination-item-ellipsis">
    <InlineIcon icon="heroicons-solid:dots-horizontal" />
  </button>
);
